module.exports = __webpack_public_path__ + "img/category-detail-icon5.e1032967.svg";